export type RGBA = {
  red: number
  green: number
  blue: number
  alpha: number
}

export const ColorUtilities = {
  isLightColor,
  hexToRgba
}

export function isLightColor(hex: string): boolean {
  const rgba = parseHex(hex)

  if (!rgba) {
    return false
  }

  if (rgba.alpha <= 0) {
    return true
  }

  return srgbLuma(rgba) > 0.673
}

export function hexToRgba(hex: string, manualOpacity?: number): RGBA {
  const rgba = parseHex(hex)

  if (!rgba) {
    throw new Error("Invalid hex color")
  }

  if (manualOpacity !== undefined) {
    rgba.alpha = Math.round(manualOpacity * 255)
  }

  return rgba
}

function parseHex(hex: string): RGBA | null {
  let cleaned = hex.replace("#", "")

  if (cleaned.length === 3) {
    cleaned = cleaned
      .split("")
      .map((c) => c + c)
      .join("")
  }

  if (cleaned.length !== 6 && cleaned.length !== 8) {
    return null
  }

  const r = parseInt(cleaned.substring(0, 2), 16)
  const g = parseInt(cleaned.substring(2, 4), 16)
  const b = parseInt(cleaned.substring(4, 6), 16)

  const a =
    cleaned.length === 8
      ? parseInt(cleaned.substring(6, 8), 16)
      : 255

  return {
    red: r,
    green: g,
    blue: b,
    alpha: a
  }
}

function srgbLuma(c: RGBA): number {
  return (
    (0.2126 * c.red +
      0.7152 * c.green +
      0.0722 * c.blue) /
    255
  )
}
